import { useCallback, useMemo, useState } from 'react';
import { OPEN_ACTIVITY_QUICK_VIEW_MODAL } from 'crm-events-data';
import ActivityQuickViewModalContainerAsync from '../crm_ui/timeline/components/generic/header/ActivityQuickViewModalContainerAsync';
// @ts-expect-error Could not find a declaration file
import QueuesStore from 'crm_data/queues/QueuesStore';
// @ts-expect-error Could not find a declaration file
import { useStoreDependency } from 'general-store';
import { jsx as _jsx } from "react/jsx-runtime";
const QueuesStoreDependency = {
  stores: [QueuesStore],
  deref: () => {
    return QueuesStore.get();
  }
};
export const useActivityQuickViewModalActionHandler = () => {
  const [activityToView, setActivityToView] = useState(null);
  const queues = useStoreDependency(QueuesStoreDependency);
  const handleActivityQuickViewModalAction = useCallback((actionType, data) => {
    if (actionType === OPEN_ACTIVITY_QUICK_VIEW_MODAL) {
      setActivityToView(data);
      return;
    }
  }, [setActivityToView]);
  const handleCloseActivityQuickViewModal = useCallback(() => {
    setActivityToView(null);
  }, [setActivityToView]);
  const activityQuickViewModal = useMemo(() => {
    if (!activityToView) {
      return null;
    }
    return /*#__PURE__*/_jsx(ActivityQuickViewModalContainerAsync, {
      "data-unit-test": "activity-quick-view-modal-container",
      activityId: activityToView.id,
      ownerId: activityToView.ownerId,
      fromName: activityToView.userLastModified,
      fromEmail: activityToView.userLastModifiedEmail,
      onClose: handleCloseActivityQuickViewModal,
      queues: queues
    });
  }, [queues, activityToView, handleCloseActivityQuickViewModal]);
  return {
    handleActivityQuickViewModalAction,
    activityQuickViewModal
  };
};